import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70 } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    color: COLOR_GRAY_70,
    fontSize: 28,
    fontWeight: 400,
    textAlign: 'center',
    marginBottom: theme.spacing(6),
  },
  table: {
    minWidth: 750,
    '& thead tr th': {
      fontSize: 18,
      borderTop: '1px solid rgba(224, 224, 224, 1)',
    },
    '& tbody tr td': {
      fontSize: 16,
    },
  },
}));
